import { render, staticRenderFns } from "./BecomeInsSurvey.vue?vue&type=template&id=90c58f32"
import script from "./BecomeInsSurvey.vue?vue&type=script&lang=js"
export * from "./BecomeInsSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports